import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon from "./locales/en/common.json";
import enInvoice from "./locales/en/invoice.json";
import enDashboard from "./locales/en/dashboard.json";
import enConsultants from "./locales/en/consultants.json";
import enClients from "./locales/en/clients.json";
import enVendors from "./locales/en/vendors.json";
import enPayments from "./locales/en/payments.json";
import enExpenses from "./locales/en/expenses.json";
import enTimesheet from "./locales/en/timesheet.json";
import enTimesheets from "./locales/en/timesheets.json";
import enUsers from "./locales/en/users.json";
import enPages from "./locales/en/pages.json";
import enAccounts from "./locales/en/accounts.json";
import enSuSettings from "./locales/en/suSettings.json";
import enLogin from "./locales/en/login.json";

import zhCnCommon from "./locales/zh-CN/common.json";
import zhCnInvoice from "./locales/zh-CN/invoice.json";
import zhCnDashboard from "./locales/zh-CN/dashboard.json";
import zhCnConsultants from "./locales/zh-CN/consultants.json";
import zhCnClients from "./locales/zh-CN/clients.json";
import zhCnVendors from "./locales/zh-CN/vendors.json";
import zhCnPayments from "./locales/zh-CN/payments.json";
import zhCnExpenses from "./locales/zh-CN/expenses.json";
import zhCnTimesheet from "./locales/zh-CN/timesheet.json";
import zhCnTimesheets from "./locales/zh-CN/timesheets.json";
import zhCnUsers from "./locales/zh-CN/users.json";
import zhCnPages from "./locales/zh-CN/pages.json";
import zhCnAccounts from "./locales/zh-CN/accounts.json";
import zhCnSuSettings from "./locales/zh-CN/suSettings.json";
import zhCnLogin from "./locales/zh-CN/login.json";

const resources = {
  en: {
    common: enCommon,
    invoice: enInvoice,
    dashboard: enDashboard,
    consultants: enConsultants,
    clients: enClients,
    vendors: enVendors,
    payments: enPayments,
    expenses: enExpenses,
    timesheet: enTimesheet,
    timesheets: enTimesheets,
    users: enUsers,
    pages: enPages,
    accounts: enAccounts,
    suSettings: enSuSettings,
    login: enLogin,
  },
  "zh-CN": {
    common: zhCnCommon,
    invoice: zhCnInvoice,
    dashboard: zhCnDashboard,
    consultants: zhCnConsultants,
    clients: zhCnClients,
    vendors: zhCnVendors,
    payments: zhCnPayments,
    expenses: zhCnExpenses,
    timesheet: zhCnTimesheet,
    timesheets: zhCnTimesheets,
    users: zhCnUsers,
    pages: zhCnPages,
    accounts: zhCnAccounts,
    suSettings: zhCnSuSettings,
    login: zhCnLogin,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lang") || "en",
  fallbackLng: "en",
  defaultNS: "invoice",
  initImmediate: false,
  interpolation: {
    escapeValue: false,
  },
});

function applyLanguageUI(language) {
  if (typeof document === "undefined") return;
  const isChinese = language === "zh-CN";
  document.documentElement.lang = isChinese ? "zh-CN" : "en";
  document.body.classList.toggle("lang-zh", isChinese);
}

applyLanguageUI(i18n.language);
i18n.on("languageChanged", applyLanguageUI);

export default i18n;
